import React, { useState, useEffect } from 'react';
import {
  Form,
  Button,
  Card,
  Table,
  Modal,
  Badge,
  ListGroup,
  Spinner,
  Row,
  Col,
  Alert
} from 'react-bootstrap';
import Header from '../../layouts/Header';
import axiosInstance from '../../api/axios';import { toast } from 'react-toastify';

const ProductPriceUpdate = () => {

  const currentSkin = localStorage.getItem('skin-mode') ? 'dark' : '';
  const [skin, setSkin] = useState(currentSkin);

  const accessToken = localStorage.getItem("authToken");
  const [menuGroups, setMenuGroups] = useState([]);
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [pendingEntries, setPendingEntries] = useState([]);
  const [completedEntries, setCompletedEntries] = useState([]);
  const [showPreview, setShowPreview] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [selectedEntry, setSelectedEntry] = useState(null);
  const [productDetails, setProductDetails] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // Form state
  const [formData, setFormData] = useState({
    menuGroup: '',
    category: '',
    products: [],
    changeType: 'PRICE-UP',
    operation: 'PERCENT',
    value: '',
    scheduledAt: new Date().toISOString().slice(0, 16)
  });

  const getMenuGroup = async() => {
      setIsLoading(true);
      try {
          const headers = {
              Authorization: `Bearer ${accessToken}`,
          };
          const response = await axiosInstance.get("menu-group", { headers });
          console.log("Response of group :", response);
      
          if (response?.data?.status === true) {
              response?.data?.data?.menuGroup.forEach((item, index) => {
                  item.serialNumber = index + 1;
              });
      
              setMenuGroups(response?.data?.data?.menuGroup);
          }
      } catch (error) {
          if (error.response && error.response?.data?.status === false) {
              let errorMessage = error.response.data.error;
              toast.error(errorMessage, {
                  position: "top-right",
                  autoClose: 3000,
                  theme: "colored",
              });
          }
      } finally {
          setIsLoading(false);
      }
  }

  useEffect(() => {
    getMenuGroup();
  }, [])

  // // Mock data fetch - replace with actual API calls
  // useEffect(() => {
  //   // Fetch menu groups
  //   const fetchMenuGroups = async () => {
  //     setIsLoading(true);
  //     try {
  //       // Replace with actual API call
  //       const mockMenuGroups = [
  //         { id: '1', name: 'Food' },
  //         { id: '2', name: 'Beverages' },
  //         { id: '3', name: 'Desserts' }
  //       ];
  //       setMenuGroups(mockMenuGroups);
  //     } catch (error) {
  //       console.error('Error fetching menu groups:', error);
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   };

  //   // Fetch pending and completed entries
  //   const fetchEntries = async () => {
  //     try {
  //       // Replace with actual API calls
  //       const mockPending = [
  //         {
  //           id: '1',
  //           menuGroup: 'Food',
  //           category: 'Main Course',
  //           productCount: 5,
  //           changeType: 'PRICE-UP',
  //           operation: 'PERCENT',
  //           value: 10,
  //           scheduledAt: '2023-06-15T10:00',
  //           status: 'PENDING'
  //         }
  //       ];
  //       const mockCompleted = [
  //         {
  //           id: '2',
  //           menuGroup: 'Beverages',
  //           category: 'Cold Drinks',
  //           productCount: 3,
  //           changeType: 'PRICE-DOWN',
  //           operation: 'ACTUAL',
  //           value: 5,
  //           scheduledAt: '2023-06-10T09:00',
  //           completedAt: '2023-06-10T09:30',
  //           status: 'COMPLETED'
  //         }
  //       ];
  //       setPendingEntries(mockPending);
  //       setCompletedEntries(mockCompleted);
  //     } catch (error) {
  //       console.error('Error fetching entries:', error);
  //     }
  //   };

  //   fetchMenuGroups();
  //   fetchEntries();
  // }, []);

  // Fetch categories when menu group changes
  useEffect(() => {
    if (formData.menuGroup) {
      const fetchCategories = async () => {
        setIsLoading(true);
        try {
          // Replace with actual API call
          const mockCategories = [
            { id: '1', name: 'Starters', menuGroupId: '1' },
            { id: '2', name: 'Main Course', menuGroupId: '1' },
            { id: '3', name: 'Desserts', menuGroupId: '1' }
          ];
          setCategories(mockCategories.filter(c => c.menuGroupId === formData.menuGroup));
        } catch (error) {
          console.error('Error fetching categories:', error);
        } finally {
          setIsLoading(false);
        }
      };
      fetchCategories();
    } else {
      setCategories([]);
      setFormData(prev => ({ ...prev, category: '', products: [] }));
    }
  }, [formData.menuGroup]);

  // Fetch products when category changes
  useEffect(() => {
    if (formData.category) {
      const fetchProducts = async () => {
        setIsLoading(true);
        try {
          // Replace with actual API call
          const mockProducts = [
            { id: '1', name: 'Pasta', price: 12.99, categoryId: '2' },
            { id: '2', name: 'Pizza', price: 14.99, categoryId: '2' },
            { id: '3', name: 'Burger', price: 8.99, categoryId: '2' },
            { id: '4', name: 'Salad', price: 7.99, categoryId: '2' }
          ];
          setProducts(mockProducts.filter(p => p.categoryId === formData.category));
          setSelectedProducts([]);
        } catch (error) {
          console.error('Error fetching products:', error);
        } finally {
          setIsLoading(false);
        }
      };
      fetchProducts();
    } else {
      setProducts([]);
      setFormData(prev => ({ ...prev, products: [] }));
    }
  }, [formData.category]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleProductSelect = (productId) => {
    setSelectedProducts(prev => {
      if (prev.includes(productId)) {
        return prev.filter(id => id !== productId);
      } else {
        return [...prev, productId];
      }
    });
  };

  const handleSelectAllProducts = (e) => {
    if (e.target.checked) {
      setSelectedProducts(products.map(p => p.id));
    } else {
      setSelectedProducts([]);
    }
  };

  const calculateNewPrice = (originalPrice) => {
    if (!formData.value) return originalPrice;
    
    const value = parseFloat(formData.value);
    if (isNaN(value)) return originalPrice;

    if (formData.operation === 'PERCENT') {
      const multiplier = formData.changeType === 'PRICE-UP' ? 1 + (value / 100) : 1 - (value / 100);
      return originalPrice * multiplier;
    } else {
      return formData.changeType === 'PRICE-UP' 
        ? originalPrice + value 
        : originalPrice - value;
    }
  };

  const handlePreview = () => {
    setFormData(prev => ({ ...prev, products: selectedProducts }));
    setShowPreview(true);
  };

  const handleSubmit = () => {
    // Here you would typically make an API call to save the scheduler entry
    const newEntry = {
      id: Date.now().toString(),
      menuGroup: menuGroups.find(mg => mg.id === formData.menuGroup)?.name || '',
      category: categories.find(c => c.id === formData.category)?.name || '',
      productCount: selectedProducts.length,
      changeType: formData.changeType,
      operation: formData.operation,
      value: parseFloat(formData.value),
      scheduledAt: formData.scheduledAt,
      status: 'PENDING'
    };

    setPendingEntries(prev => [...prev, newEntry]);
    setShowPreview(false);
    resetForm();
  };

  const resetForm = () => {
    setFormData({
      menuGroup: '',
      category: '',
      products: [],
      changeType: 'PRICE-UP',
      operation: 'PERCENT',
      value: '',
      scheduledAt: new Date().toISOString().slice(0, 16)
    });
    setSelectedProducts([]);
  };

  const handleConfirmEntry = (entryId) => {
    // API call to confirm the entry
    const entry = pendingEntries.find(e => e.id === entryId);
    if (entry) {
      setPendingEntries(prev => prev.filter(e => e.id !== entryId));
      setCompletedEntries(prev => [...prev, { ...entry, status: 'CONFIRMED' }]);
    }
  };

  const handleDeleteEntry = (entryId) => {
    // API call to delete the entry
    setPendingEntries(prev => prev.filter(e => e.id !== entryId));
  };

  const handleShowDetails = (entry) => {
    setSelectedEntry(entry);
    // Here you would fetch the actual product details from the API
    // For demo, we'll use mock data
    const mockDetails = [
      { id: '1', name: 'Pasta', oldPrice: 12.99, newPrice: 14.29 },
      { id: '2', name: 'Pizza', oldPrice: 14.99, newPrice: 16.49 },
      { id: '3', name: 'Burger', oldPrice: 8.99, newPrice: 9.89 }
    ];
    setProductDetails(mockDetails);
    setShowDetails(true);
  };

  return (
    <React.Fragment>
      <Header onSkin={setSkin} />
      <div className="main main-app p-3 p-lg-4">
        <h3 className="mb-4">BULK PRICE UPDATE SCHEDULER</h3>

        <Card className="mb-4">
          <Card.Header>
            <h5>Create New Price Update</h5>
          </Card.Header>
          <Card.Body>
            <Form>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label className='fw-semibold'>Menu Group <span className="text-danger">*</span></Form.Label>
                    <Form.Select
                      name="menuGroup"
                      value={formData.menuGroup}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">Select Menu Group</option>
                      {menuGroups.map(group => (
                        <option key={group._id} value={group._id}>{group.groupName}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label className='fw-semibold'>Category</Form.Label>
                    <Form.Select
                      name="category"
                      value={formData.category}
                      onChange={handleInputChange}
                      disabled={!formData.menuGroup}
                    >
                      <option value="">Select Category (Optional)</option>
                      {categories.map(category => (
                        <option key={category.id} value={category.id}>{category.name}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              {products.length > 0 && (
                <Form.Group className="mb-3">
                  <Form.Label className='fw-semibold'>Select Products (Optional)</Form.Label>
                  <Card>
                    <Card.Body style={{ maxHeight: '200px', overflowY: 'auto' }}>
                      <Form.Check
                        type="checkbox"
                        label="Select All"
                        checked={selectedProducts.length === products.length}
                        onChange={handleSelectAllProducts}
                        className="mb-2"
                      />
                      <ListGroup variant="flush">
                        {products.map(product => (
                          <ListGroup.Item key={product.id}>
                            <Form.Check
                              type="checkbox"
                              id={`product-${product.id}`}
                              label={`${product.name} - $${product.price.toFixed(2)}`}
                              checked={selectedProducts.includes(product.id)}
                              onChange={() => handleProductSelect(product.id)}
                            />
                          </ListGroup.Item>
                        ))}
                      </ListGroup>
                    </Card.Body>
                  </Card>
                </Form.Group>
              )}

              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label className='fw-semibold'>Change Type <span className="text-danger">*</span></Form.Label>
                    <Form.Select
                      name="changeType"
                      value={formData.changeType}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="PRICE-UP">Price Increase</option>
                      <option value="PRICE-DOWN">Price Decrease</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label className='fw-semibold'>Operation <span className="text-danger">*</span></Form.Label>
                    <Form.Select
                      name="operation"
                      value={formData.operation}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="PERCENT">Percentage (%)</option>
                      <option value="ACTUAL">Actual Amount ($)</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label className='fw-semibold'>Value <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="number"
                      name="value"
                      value={formData.value}
                      onChange={handleInputChange}
                      required
                      min="0"
                      step={formData.operation === 'PERCENT' ? '0.1' : '0.01'}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Form.Group className="mb-3">
                <Form.Label className='fw-semibold'>Scheduled Date/Time</Form.Label>
                <Form.Control
                  type="datetime-local"
                  name="scheduledAt"
                  value={formData.scheduledAt}
                  onChange={handleInputChange}
                />
              </Form.Group>

              <div className="d-flex justify-content-end gap-2">
                <Button variant="secondary" onClick={resetForm}>
                  Reset
                </Button>
                <Button 
                  variant="primary" 
                  onClick={handlePreview}
                  disabled={!formData.menuGroup || !formData.value || isLoading}
                >
                  {isLoading ? <Spinner size="sm" /> : 'Preview Changes'}
                </Button>
              </div>
            </Form>
          </Card.Body>
        </Card>

        {/* Pending Entries */}
        {pendingEntries.length > 0 && (
          <Card className="mb-4">
            <Card.Header>
              <h5>Pending Price Updates</h5>
            </Card.Header>
            <Card.Body>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>Menu Group</th>
                    <th>Category</th>
                    <th>Products</th>
                    <th>Change</th>
                    <th>Scheduled At</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {pendingEntries.map(entry => (
                    <tr key={entry.id}>
                      <td>{entry.menuGroup}</td>
                      <td>{entry.category || 'All'}</td>
                      <td>{entry.productCount}</td>
                      <td>
                        {entry.changeType === 'PRICE-UP' ? '+' : '-'}
                        {entry.value}
                        {entry.operation === 'PERCENT' ? '%' : '$'}
                      </td>
                      <td>{new Date(entry.scheduledAt).toLocaleString()}</td>
                      <td><Badge bg="warning">{entry.status}</Badge></td>
                      <td>
                        <Button
                          variant="success"
                          size="sm"
                          className="me-2"
                          onClick={() => handleConfirmEntry(entry.id)}
                        >
                          Confirm
                        </Button>
                        <Button
                          variant="danger"
                          size="sm"
                          className="me-2"
                          onClick={() => handleDeleteEntry(entry.id)}
                        >
                          Delete
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Card.Body>
          </Card>
        )}

        {/* Completed Entries */}
        {completedEntries.length > 0 && (
          <Card className="mb-4">
            <Card.Header>
              <h5>Completed Price Updates</h5>
            </Card.Header>
            <Card.Body>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>Menu Group</th>
                    <th>Category</th>
                    <th>Products</th>
                    <th>Change</th>
                    <th>Completed At</th>
                    <th>Status</th>
                    <th>Details</th>
                  </tr>
                </thead>
                <tbody>
                  {completedEntries.map(entry => (
                    <tr key={entry.id}>
                      <td>{entry.menuGroup}</td>
                      <td>{entry.category || 'All'}</td>
                      <td>
                        <Button 
                          variant="link" 
                          onClick={() => handleShowDetails(entry)}
                        >
                          {entry.productCount}
                        </Button>
                      </td>
                      <td>
                        {entry.changeType === 'PRICE-UP' ? '+' : '-'}
                        {entry.value}
                        {entry.operation === 'PERCENT' ? '%' : '$'}
                      </td>
                      <td>{new Date(entry.completedAt).toLocaleString()}</td>
                      <td><Badge bg="success">{entry.status}</Badge></td>
                      <td>
                        <Button
                          variant="info"
                          size="sm"
                          onClick={() => handleShowDetails(entry)}
                        >
                          View
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Card.Body>
          </Card>
        )}

        {/* Preview Modal */}
        <Modal show={showPreview} onHide={() => setShowPreview(false)} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Price Update Preview</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
              You're about to update prices for{' '}
              <strong>
                {selectedProducts.length > 0 
                  ? `${selectedProducts.length} selected products` 
                  : `all products in ${menuGroups.find(mg => mg.id === formData.menuGroup)?.name}${
                      formData.category ? ` > ${categories.find(c => c.id === formData.category)?.name}` : ''
                    }`
                }
              </strong>
            </p>

            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Product</th>
                  <th>Current Price</th>
                  <th>New Price</th>
                  <th>Change</th>
                </tr>
              </thead>
              <tbody>
                {products
                  .filter(p => selectedProducts.length === 0 || selectedProducts.includes(p.id))
                  .slice(0, 5) // Show first 5 for preview
                  .map(product => (
                    <tr key={product.id}>
                      <td>{product.name}</td>
                      <td>${product.price.toFixed(2)}</td>
                      <td>${calculateNewPrice(product.price).toFixed(2)}</td>
                      <td>
                        {formData.changeType === 'PRICE-UP' ? '+' : '-'}
                        {formData.value}
                        {formData.operation === 'PERCENT' ? '%' : '$'}
                      </td>
                    </tr>
                  ))}
                {products.length > 5 && (
                  <tr>
                    <td colSpan={4} className="text-center">
                      + {products.length - 5} more products
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>

            <Alert variant="warning">
              This update will be scheduled for{' '}
              <strong>{new Date(formData.scheduledAt).toLocaleString()}</strong>. 
              The status will be PENDING until manually confirmed by an admin.
            </Alert>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowPreview(false)}>
              Back to Edit
            </Button>
            <Button variant="primary" onClick={handleSubmit}>
              Schedule Price Update
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Details Modal */}
        <Modal show={showDetails} onHide={() => setShowDetails(false)} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>
              Price Update Details - {selectedEntry?.menuGroup}
              {selectedEntry?.category && ` > ${selectedEntry.category}`}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="mb-3">
              <p>
                <strong>Change:</strong> {selectedEntry?.changeType === 'PRICE-UP' ? 'Increase' : 'Decrease'} by{' '}
                {selectedEntry?.value}{selectedEntry?.operation === 'PERCENT' ? '%' : '$'}
              </p>
              <p>
                <strong>Scheduled At:</strong> {selectedEntry?.scheduledAt && new Date(selectedEntry.scheduledAt).toLocaleString()}
              </p>
              <p>
                <strong>Completed At:</strong> {selectedEntry?.completedAt && new Date(selectedEntry.completedAt).toLocaleString()}
              </p>
            </div>

            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Product</th>
                  <th>Old Price</th>
                  <th>New Price</th>
                  <th>Difference</th>
                </tr>
              </thead>
              <tbody>
                {productDetails.map(product => (
                  <tr key={product.id}>
                    <td>{product.name}</td>
                    <td>${product.oldPrice.toFixed(2)}</td>
                    <td>${product.newPrice.toFixed(2)}</td>
                    <td>
                      {product.newPrice >= product.oldPrice ? '+' : '-'}
                      ${Math.abs(product.newPrice - product.oldPrice).toFixed(2)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowDetails(false)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </React.Fragment>
  );
};

export default ProductPriceUpdate;